import { Alert } from "../../../components/attentions";

const LimitAlert: React.FC<{ message: string }> = ({ message }) => (
  <Alert type="error" icon="icon-warning" className="py-4 pr-4 icon-top-[4.5rem]">
    <p>{message}</p>
  </Alert>
);

export default LimitAlert;
